import { useNavigate } from "react-router-dom";
import "./Services.css";

import Service1 from "./images/service1.webp";
import Service2 from "./images/service2.webp";
import Service3 from "./images/services3.webp";

const Services = () => {

    const navigate = useNavigate();

    return (<div id="learn_more" className="services-main" >

        <div className="services-1">

            <h2>Smart and clever kids <br /> ready to <span>fly high !</span></h2>
            <p>The education of even a small child,<br /> therefore, does not aim at preparing <br /> him for school, but for life.</p>
            <button className="get-started-btn" onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")}>Enroll Now <i className="fa-solid fa-arrow-up"></i></button>

        </div>

        <div className="services-2">

            <div className="services-2-sub" style={{ backgroundImage: `url(${Service1})` }} >
                <h4>Toddler <br /> <span>Program</span></h4>
                <button onClick={() => navigate("/programs/toddler-program")} className="get-started-btn">EXPLORE</button>
            </div>
            <div className="services-2-sub" style={{ backgroundImage: `url(${Service2})` }} >
                <h4>Primary <br /> <span>Program</span></h4>
                <button onClick={() => navigate("/programs/primary-program")} className="get-started-btn">EXPLORE</button>
            </div>
            <div className="services-2-sub" style={{ backgroundImage: `url(${Service3})` }} >
                <h4>Elementary <br /> <span>Program</span></h4>
                <button onClick={() => navigate("/programs/elementary-program")} className="get-started-btn">EXPLORE</button>
            </div>

        </div>

    </div>)

}

export default Services;